module.exports = __webpack_public_path__ + "static/media/mobile-nav.c0c977ad.svg";